import type { DeviceInfo as DeviceInfoType } from '@/hooks/useDeviceInfo';
import { useTestStore } from '@/store/useTestStore';
import { t } from '@/i18n/translations';

interface DeviceInfoProps {
  info: DeviceInfoType;
}

export function DeviceInfo({ info }: DeviceInfoProps) {
  const lang = useTestStore((s) => s.language);

  return (
    <div className="border border-border rounded-[18px] bg-white/[.01] p-3">
      <h3 className="text-sm font-bold mb-2">{t('overview.envTitle', lang)}</h3>
      <div className="text-xs text-muted font-mono leading-relaxed whitespace-pre-wrap">
        {`${t('overview.tvHint', lang)}: ${info.tvHint}
Screen: ${info.screenWidth ?? '—'}x${info.screenHeight ?? '—'}  DPR: ${info.dpr}
deviceMemory: ${info.deviceMemory != null ? info.deviceMemory + ' GB' : 'n/a'} (${info.memHint})
cores: ${info.hardwareConcurrency ?? 'n/a'}
touch: ${info.touchSupport ? 'yes' : 'no'} (max ${info.maxTouchPoints} points)`}
      </div>
      <details className="mt-2">
        <summary className="text-xs text-muted cursor-pointer">UA</summary>
        <p className="text-xs text-muted font-mono mt-1 break-all">{info.ua}</p>
      </details>
    </div>
  );
}
